import { ErrorLike } from "@apollo/client"
import { useQuery } from "@apollo/client/react"
import { useTokenData } from "../../../hooks/useTokenData"
import { queryUsers } from "../queries/LoginUser"
import { usersInfo } from "../queries/__generated-typings__/LoginUser"

type Info = {
  profileId?: string | null
  contactId?: string | null
  mobile?: string | null
  email?: string | null
  firstName?: string | null
  lastName?: string | null
  companyName?: string | null
  companyTaxCode?: string | null
  taxCode?: string | null
}

type UsersInfo = {
  data: { user: Info } | null
  loading: boolean
  error?: ErrorLike
}

export const useUsersInfo = (): UsersInfo => {
  const { data: userData } = useTokenData()
  const email = userData?.email
  const vat = userData?.companyVatCode

  const { data, error, loading } = useQuery<usersInfo>(queryUsers, {
    skip: !email || !vat,
    variables: { email, vat }
  })

  if (data) {
    const firstCompany = data.companies[0] ?? undefined
    const firstUser = firstCompany ? firstCompany.profiles[0] : undefined

    const user: Info = {
      profileId: firstUser?.sfid ?? null,
      contactId: firstUser?.contact?.sfid ?? null,
      mobile: firstUser?.contact?.mobile ?? null,
      firstName: firstUser?.contact?.first_name ?? null,
      lastName: firstUser?.contact?.last_name ?? null,
      companyName: firstCompany?.business_name ?? null,
      companyTaxCode: firstCompany?.tax_code ?? null,
      taxCode: firstUser?.contact?.tax_code ?? null,
      email
    }

    return { data: { user }, loading, error }
  }

  return { data: null, loading, error }
}
